import client from 'api/client';

export const fetchUsage = ({uid, locale, oid: orgId}) => client().post(`/user/${uid}/plan/`, {locale, orgId});
